
function injectCommonHeader(containerId, breadcrumbTitle, basePath = '') {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Set default visibility based on previous state or default true initially
  // We will fetch real config shortly
  const initialDisplay = 'block'; // Or 'none' to avoid flash

  const headerHTML = `
    <header class="header header-sticky p-0 mb-0">
      <div class="container-fluid border-bottom px-4">
        <button class="header-toggler" type="button" onclick="const s=document.querySelector('#sidebar'); const p=document.getElementById('pageListPanel'); if(p && typeof togglePageListPanel==='function'){togglePageListPanel()} else if(s && window.coreui) coreui.Sidebar.getInstance(s).toggle();" style="margin-inline-start: -14px;">
          <svg class="icon icon-lg">
            <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-menu"></use>
          </svg>
        </button>
        <ul class="header-nav d-flex align-items-center" style="margin-left: 1rem;" id="headerNavLinks">
          <li class="nav-item">
            <a class="nav-link" href="${basePath}index.html">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-speedometer"></use>
              </svg> Dashboard
            </a>
          </li>
          <li class="nav-item" id="navItemEvents" style="display:${initialDisplay};">
            <a class="nav-link" href="${basePath}admin/system-logs?tab=event">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-stream"></use>
              </svg> Events
            </a>
          </li>
          <li class="nav-item dropdown" id="navItemReports">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-coreui-toggle="dropdown" aria-expanded="false">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-chart-line"></use>
              </svg> Raporlar
            </a>
            <ul class="dropdown-menu" id="reportsDropdownMenu">
              <li id="navItemChillerReport"><a class="dropdown-item" href="${basePath}Report/ChillerDailyReport">
                <svg class="icon icon-sm me-2"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-snow"></use></svg>Chiller Raporu
              </a></li>
              <li id="navItem5minReport"><a class="dropdown-item" href="${basePath}Report/5minReport">
                <svg class="icon icon-sm me-2"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-av-timer"></use></svg>5 Dakika Raporu
              </a></li>
              <li><hr class="dropdown-divider" id="reportsDropdownDivider" style="display:none;"></li>
              <!-- Generic reports injected here by fetchAndApplyMenuConfig -->
              <li><hr class="dropdown-divider" id="schedulerDropdownDivider"></li>
              <li><a class="dropdown-item" href="${basePath}admin/report-scheduler">
                <svg class="icon icon-sm me-2"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-clock"></use></svg>Rapor Zamanlayıcı
              </a></li>
            </ul>
          </li>
        </ul>
        <ul class="header-nav ms-auto">
          <li class="nav-item dropdown">
            <button class="btn btn-link nav-link" id="hubBellBtn" type="button" aria-expanded="false" title="NexBus alerts">
              <span class="nav-icon-wrapper" style="position: relative; display:inline-block;">
                <svg id="bellIconSvg" class="icon icon-lg">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-bell"></use>
                </svg>
              </span>
            </button>
          </li>
          <li class="nav-item dropdown">
            <button class="btn btn-link nav-link" id="hubDropdownBtn" type="button" data-coreui-toggle="dropdown" aria-expanded="false" title="NexBus hub status">
              <span class="nav-icon-wrapper" style="position: relative; display:inline-block;">
                <svg class="icon icon-lg">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-list-rich"></use>
                </svg>
                <span id="hubIndicatorDot" class="hub-indicator hub-disconnected" title="NexBus hub status" aria-hidden="true" style="pointer-events:none; position:absolute; top:2px; right:-6px; width:8px; height:8px; border-radius:50%; background:#6c757d; border:1px solid #fff;"></span>
              </span>
            </button>
            <ul id="hubConnectionDropdown" class="dropdown-menu dropdown-menu-start" style="min-width: 220px;">
              <li class="dropdown-item"><strong id="hubPopupStatus">Hub: disconnected</strong></li>
              <li class="dropdown-item d-flex justify-content-between align-items-center">
                <span id="hubPopupTags">Tags: 0</span>
                <button class="btn btn-sm btn-ghost-info ms-2 py-0 px-1" onclick="if(window.openHubDetailModal) window.openHubDetailModal()" title="İzle">
                  <svg class="icon"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-external-link"></use></svg>
                </button>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li class="dropdown-item small text-muted" id="hubPopupList">No tags subscribed</li>
            </ul>
          </li>
          <li class="nav-item py-1">
            <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <li class="nav-item dropdown">
            <button class="btn btn-link nav-link py-2 px-2 d-flex align-items-center" type="button" aria-expanded="false" data-coreui-toggle="dropdown">
              <svg class="icon icon-lg theme-icon-active">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-contrast"></use>
              </svg>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" style="--cui-dropdown-min-width: 8rem;">
              <li>
                <button class="dropdown-item d-flex align-items-center" type="button" data-coreui-theme-value="light">
                  <svg class="icon icon-lg me-3">
                    <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-sun"></use>
                  </svg>Light
                </button>
              </li>
              <li>
                <button class="dropdown-item d-flex align-items-center" type="button" data-coreui-theme-value="dark">
                  <svg class="icon icon-lg me-3">
                    <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-moon"></use>
                  </svg>Dark
                </button>
              </li>
              <li>
                <button class="dropdown-item d-flex align-items-center active" type="button" data-coreui-theme-value="auto">
                  <svg class="icon icon-lg me-3">
                    <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-contrast"></use>
                  </svg>Auto
                </button>
              </li>
            </ul>
          </li>
          <li class="nav-item py-1">
            <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <li class="nav-item dropdown"><a class="nav-link py-0 pe-0" data-coreui-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
              <div class="avatar avatar-md"><img class="avatar-img" src="${basePath}assets/img/avatars/noname.jpg" alt="user@email.com"></div></a>
            <div class="dropdown-menu dropdown-menu-end pt-0">
              <div class="dropdown-header bg-body-tertiary text-body-secondary fw-semibold rounded-top mb-2">
                <div id="userDisplayName" class="fw-semibold">Loading...</div>
                <small id="userEmail" class="text-muted"></small>
              </div>
              <a class="dropdown-item" href="#" onclick="openChangePasswordModal(event)">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-lock-locked"></use>
                </svg> Şifre Değiştir
              </a>
              <a class="dropdown-item" href="${basePath}settings.html" id="settingsLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-settings"></use>
                </svg> Settings
              </a>
              <a class="dropdown-item" href="${basePath}admin/index.html" id="adminPanelLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-applications-settings"></use>
                </svg> Admin Panel
              </a>
              <a class="dropdown-item" href="${basePath}admin/nexbus-config.html" id="nexbusConfigLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-router"></use>
                </svg> NexBus Config
              </a>
              <a class="dropdown-item" href="${basePath}admin/report-scheduler" id="reportSchedulerLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-clock"></use>
                </svg> Rapor Zamanlayıcı
              </a>
              <a class="dropdown-item" href="#" onclick="showDrInfo(event)">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-info"></use>
                </svg> Dr Info
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" id="logoutBtn">
                <svg class="icon me-2 text-danger">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-account-logout"></use>
                </svg> <span class="text-danger">Logout</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
      ${breadcrumbTitle ? `
      <div class="header-divider"></div>
      <div class="container-fluid">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb my-0 ms-2">
            <li class="breadcrumb-item"><a href="${basePath}index.html">Home</a></li>
            <li class="breadcrumb-item active"><span>${breadcrumbTitle}</span></li>
          </ol>
        </nav>
      </div>` : ''}
    </header>

    <!-- DR Info Modal -->
    <!-- Change Password Modal -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true" style="z-index: 100000;">
      <div class="modal-dialog" style="z-index: 100001;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-lock me-2"></i>Şifre Değiştir</h5>
            <button type="button" class="btn-close" data-coreui-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Mevcut Şifre</label>
              <input type="password" class="form-control" id="currentPassword" placeholder="Mevcut şifrenizi girin">
            </div>
            <div class="mb-3">
              <label class="form-label">Yeni Şifre</label>
              <input type="password" class="form-control" id="newPassword" placeholder="Yeni şifrenizi girin">
            </div>
            <div class="mb-3">
              <label class="form-label">Yeni Şifre (Tekrar)</label>
              <input type="password" class="form-control" id="confirmNewPassword" placeholder="Yeni şifrenizi tekrar girin">
            </div>
            <div id="changePasswordError" class="alert alert-danger d-none"></div>
            <div id="changePasswordSuccess" class="alert alert-success d-none"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-coreui-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-primary" id="changePasswordBtn" onclick="submitChangePassword()">
              <i class="fas fa-save me-1"></i>Şifreyi Değiştir
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- DR Info Modal -->
    <div class="modal fade" id="drInfoModal" tabindex="-1" aria-hidden="true" style="z-index: 100000;">
      <div class="modal-dialog modal-lg" style="z-index: 100001;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-info-circle me-2"></i>DataRapor Info</h5>
            <button type="button" class="btn-close" data-coreui-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" id="drInfoModalBody">
            <ul class="nav nav-tabs mb-3" id="drInfoTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="tab-company-btn" data-coreui-toggle="tab" data-coreui-target="#tab-company" type="button" role="tab"><i class="fas fa-building me-1"></i>Firma Bilgileri</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="tab-license-btn" data-coreui-toggle="tab" data-coreui-target="#tab-license" type="button" role="tab"><i class="fas fa-key me-1"></i>Lisans</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="tab-system-btn" data-coreui-toggle="tab" data-coreui-target="#tab-system" type="button" role="tab"><i class="fas fa-server me-1"></i>Sistem</button>
              </li>
            </ul>
            <div class="tab-content">
              <!-- FIRMA TAB -->
              <div class="tab-pane fade show active" id="tab-company" role="tabpanel">
                <div class="row g-3">
                  <div class="col-md-4 text-center">
                    <div id="companyLogoBox" style="width:100%;min-height:140px;border:2px dashed #6c757d;border-radius:8px;display:flex;align-items:center;justify-content:center;background:#f8f9fa;overflow:hidden;">
                      <span class="text-muted"><i class="fas fa-image fa-3x"></i></span>
                    </div>
                    <div class="mt-2 d-none" id="companyLogoControls">
                      <label class="btn btn-sm btn-outline-primary w-100">
                        <i class="fas fa-upload me-1"></i>Logo Yükle
                        <input type="file" id="companyLogoInput" accept="image/png,image/jpeg,image/svg+xml" hidden>
                      </label>
                      <button class="btn btn-sm btn-outline-danger w-100 mt-1" onclick="removeCompanyLogo()"><i class="fas fa-trash me-1"></i>Kaldır</button>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="mb-2"><label class="form-label mb-0 small text-muted">Firma Adı</label><input class="form-control form-control-sm company-field" data-field="companyName" placeholder="Firma Adı"></div>
                    <div class="mb-2"><label class="form-label mb-0 small text-muted">Adres</label><textarea class="form-control form-control-sm company-field" data-field="address" rows="2" placeholder="Adres"></textarea></div>
                    <div class="row g-2">
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">Telefon</label><input class="form-control form-control-sm company-field" data-field="phone" placeholder="+90..."></div>
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">E-posta</label><input class="form-control form-control-sm company-field" data-field="email" placeholder="info@..."></div>
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">Web Sitesi</label><input class="form-control form-control-sm company-field" data-field="website" placeholder="https://..."></div>
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">Vergi No</label><input class="form-control form-control-sm company-field" data-field="taxNumber" placeholder="Vergi Numarası"></div>
                    </div>
                    <div id="companyEditHint" class="small text-muted d-none"><i class="fas fa-info-circle"></i> Düzenleme yetkisi admin kullanıcılarla sınırlıdır.</div>
                  </div>
                </div>
              </div>
              <!-- LISANS TAB -->
              <div class="tab-pane fade" id="tab-license" role="tabpanel">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr><th style="width:200px;">Durum</th><td id="drInfoLicenseStatus">-</td></tr>
                      <tr><th>Müşteri</th><td id="drInfoLicenseCustomer">-</td></tr>
                      <tr><th>Geçerlilik Sonu</th><td id="drInfoLicenseExpiry">-</td></tr>
                      <tr><th>Kalan Gün</th><td id="drInfoLicenseDays">-</td></tr>
                      <tr><th>Instance</th><td id="drInfoLicenseInstance">-</td></tr>
                      <tr><th>Fingerprint</th><td id="drInfoLicenseFingerprint" style="font-family:monospace;font-size:11px;word-break:break-all;">-</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- SISTEM TAB -->
              <div class="tab-pane fade" id="tab-system" role="tabpanel">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr><th style="width:200px;">Uygulama Versiyonu</th><td id="drInfoVersion">-</td></tr>
                      <tr><th>Instance</th><td id="drInfoInstance">-</td></tr>
                      <tr><th>Backend URL</th><td id="drInfoBackend">-</td></tr>
                      <tr><th>Ortam</th><td id="drInfoEnv">-</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-success me-auto" id="drInfoPdfBtn" onclick="exportDrInfoPdf()"><i class="fas fa-file-pdf me-1"></i>PDF Çıktısı</button>
            <button type="button" class="btn btn-primary d-none" id="drInfoSaveBtn" onclick="saveCompanyInfo()"><i class="fas fa-save me-1"></i>Kaydet</button>
            <button type="button" class="btn btn-secondary" data-coreui-dismiss="modal">Kapat</button>
          </div>
        </div>
      </div>
    </div>
  `;

  container.innerHTML = headerHTML;

  // Fix: Z-Index/Backdrop issue
  // Move the modal to the body immediately after injection
  // This prevents it from being trapped in stacked contexts (like sticky headers)
  const infoModal = document.getElementById('drInfoModal');
  if (infoModal && document.body) {
      document.body.appendChild(infoModal);
  }

  fetchAndApplyMenuConfig();

  // Initialize User Info
  if (window.Auth) {
    const userInfo = window.Auth.getUserInfo();
    if (userInfo) {
      const displayNameEl = document.getElementById('userDisplayName');
      const emailEl = document.getElementById('userEmail');
      const settingsLink = document.getElementById('settingsLink');
      const adminPanelLink = document.getElementById('adminPanelLink');
      const nexbusConfigLink = document.getElementById('nexbusConfigLink');
      const reportSchedulerLink = document.getElementById('reportSchedulerLink');
      
      if (displayNameEl) displayNameEl.textContent = userInfo.name || userInfo.username || userInfo.UserName || userInfo.FirstName || 'User';
      if (emailEl) emailEl.textContent = userInfo.email || userInfo.Email || '';
      
      // Rol bazlı menü kontrolü
      // Role: 'user' (standart), 'admin' (yönetici), 'super_admin' (tam yetki)
      const userRole = (userInfo.Role || userInfo.role || 'user').toLowerCase();
      const isAdmin = userRole === 'admin' || userRole === 'super_admin';
      const isSuperAdmin = userRole === 'super_admin';
      
      // Eski GroupPermission uyumluluğu (geriye dönük)
      const gp = userInfo.group_permission || userInfo.GroupPermission;
      const legacyAdmin = (gp === 'Admin' || gp === 'Root' || gp === 1 || gp === '1');
      
      const showAdmin = isAdmin || legacyAdmin;
      const showSuperAdmin = isSuperAdmin || (gp === 'Root' || gp === 1 || gp === '1');
      
      // Settings: admin ve üzeri
      if (settingsLink) settingsLink.style.display = showAdmin ? 'block' : 'none';
      // Admin Panel: admin ve üzeri
      if (adminPanelLink) adminPanelLink.style.display = showAdmin ? 'block' : 'none';
      // NexBus Config: sadece super_admin
      if (nexbusConfigLink) nexbusConfigLink.style.display = showSuperAdmin ? 'block' : 'none';
      // Rapor Zamanlayıcı: admin ve üzeri
      if (reportSchedulerLink) reportSchedulerLink.style.display = showAdmin ? 'block' : 'none';
    }
  }

  // Initialize Logout
  const logoutBtn = document.getElementById('logoutBtn');
  if (logoutBtn) {
    logoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.Auth && typeof window.Auth.logout === 'function') {
        window.Auth.logout();
      }
    });
  }
}

// ─── Şifre Değiştir ───
function openChangePasswordModal(e) {
    if(e) e.preventDefault();
    // Reset fields
    document.getElementById('currentPassword').value = '';
    document.getElementById('newPassword').value = '';
    document.getElementById('confirmNewPassword').value = '';
    document.getElementById('changePasswordError').classList.add('d-none');
    document.getElementById('changePasswordSuccess').classList.add('d-none');
    document.getElementById('changePasswordBtn').disabled = false;
    
    const modalEl = document.getElementById('changePasswordModal');
    if (modalEl && window.coreui) {
        if (modalEl.parentElement !== document.body || document.body.lastElementChild !== modalEl) {
            document.body.appendChild(modalEl);
        }
        const modal = new coreui.Modal(modalEl, { backdrop: true });
        modal.show();
    }
}

async function submitChangePassword() {
    const errorEl = document.getElementById('changePasswordError');
    const successEl = document.getElementById('changePasswordSuccess');
    const btn = document.getElementById('changePasswordBtn');
    
    errorEl.classList.add('d-none');
    successEl.classList.add('d-none');
    
    const currentPassword = document.getElementById('currentPassword').value.trim();
    const newPassword = document.getElementById('newPassword').value.trim();
    const confirmNewPassword = document.getElementById('confirmNewPassword').value.trim();
    
    if (!currentPassword || !newPassword || !confirmNewPassword) {
        errorEl.textContent = 'Tüm alanları doldurun.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    if (newPassword !== confirmNewPassword) {
        errorEl.textContent = 'Yeni şifreler eşleşmiyor.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    if (newPassword.length < 4) {
        errorEl.textContent = 'Yeni şifre en az 4 karakter olmalıdır.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    // Kullanıcı bilgisi
    const userInfo = window.Auth ? window.Auth.getUserInfo() : null;
    if (!userInfo || !userInfo.UserName) {
        errorEl.textContent = 'Kullanıcı bilgisi alınamadı. Lütfen tekrar giriş yapın.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Kaydediliyor...';
    
    try {
        const basePath = window.API_BASE_URL || '';
        const resp = await fetch(`${basePath}/api/users/change-password`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${window.Auth.getToken()}`
            },
            body: JSON.stringify({
                username: userInfo.UserName,
                current_password: currentPassword,
                new_password: newPassword
            })
        });
        
        const data = await resp.json();
        
        if (!resp.ok) {
            throw new Error(data.error || 'Şifre değiştirme başarısız.');
        }
        
        successEl.textContent = 'Şifre başarıyla değiştirildi!';
        successEl.classList.remove('d-none');
        
        // 2 saniye sonra modalı kapat
        setTimeout(() => {
            const modalEl = document.getElementById('changePasswordModal');
            const modal = coreui.Modal.getInstance(modalEl);
            if (modal) modal.hide();
        }, 2000);
        
    } catch (err) {
        errorEl.textContent = err.message;
        errorEl.classList.remove('d-none');
    } finally {
        btn.disabled = false;
        btn.innerHTML = '<i class="fas fa-save me-1"></i>Şifreyi Değiştir';
    }
}

async function showDrInfo(e) {
    if(e) e.preventDefault();
    
    // Show Modal immediately
    const modalEl = document.getElementById('drInfoModal');
    if (modalEl && window.coreui) {
        
        // Final Safety: Ensure it is the last child of body every time we open it
        // This defeats any subsequent stacking contexts created by other libs
        if (modalEl.parentElement !== document.body || document.body.lastElementChild !== modalEl) {
             document.body.appendChild(modalEl);
        }

        const modal = window.coreui.Modal.getInstance(modalEl) || new window.coreui.Modal(modalEl);
        
        // Manual fix for "Tamam" button click if data-attribute fails
        const dismissBtns = modalEl.querySelectorAll('[data-coreui-dismiss="modal"]');
        dismissBtns.forEach(btn => {
            btn.onclick = () => modal.hide();
        });

        modal.show();
    } else {
        console.error('Modal element or CoreUI not found');
        return;
    }

    // Yetki kontrolu — admin/super_admin firma bilgilerini duzenleyebilir
    // Hem yeni "role" alanı hem de eski "GroupPermission" (Admin/Root/SuperAdmin) destekleniyor
    let canEdit = false;
    try {
        if (window.Auth && typeof window.Auth.getUserInfo === 'function') {
            const u = window.Auth.getUserInfo() || {};
            const role = String(u.Role || u.role || '').toLowerCase();
            const gp = String(u.GroupPermission || u.group_permission || '').toLowerCase();
            const uname = String(u.UserName || u.username || '').toLowerCase();
            const legacyAdmin = gp === 'admin' || gp === 'root' || gp === 'superadmin' || gp === 'super_admin' || gp === '1' || gp === '0';
            canEdit = role === 'admin' || role === 'super_admin' || legacyAdmin || uname === 'admin';
            // Debug: yetki tespiti için konsola bas
            try { console.log('[DrInfo] user:', u, 'role:', role, 'gp:', gp, 'canEdit:', canEdit); } catch {}
        }
    } catch {}
    const saveBtn = document.getElementById('drInfoSaveBtn');
    const logoCtl = document.getElementById('companyLogoControls');
    const editHint = document.getElementById('companyEditHint');
    if (saveBtn) saveBtn.classList.toggle('d-none', !canEdit);
    if (logoCtl) logoCtl.classList.toggle('d-none', !canEdit);
    if (editHint) editHint.classList.toggle('d-none', canEdit);
    document.querySelectorAll('.company-field').forEach(el => {
        el.disabled = !canEdit;
        el.readOnly = !canEdit;
    });

    // Firma bilgilerini yukle
    loadCompanyInfo();

    // Logo input listener
    const logoInput = document.getElementById('companyLogoInput');
    if (logoInput && !logoInput.dataset.bound) {
        logoInput.addEventListener('change', handleCompanyLogoSelect);
        logoInput.dataset.bound = '1';
    }

    // Try to find API_BASE if defined globally, otherwise guess
    const apiBase = (typeof API_BASE !== 'undefined') ? API_BASE : '/admin/api/nexbus';
    
    const backendEl = document.getElementById('drInfoBackend');
    const envEl = document.getElementById('drInfoEnv');
    const versionEl = document.getElementById('drInfoVersion');
    const instanceEl = document.getElementById('drInfoInstance');
    const licStatusEl = document.getElementById('drInfoLicenseStatus');
    const licCustEl = document.getElementById('drInfoLicenseCustomer');
    const licExpEl = document.getElementById('drInfoLicenseExpiry');
    const licDaysEl = document.getElementById('drInfoLicenseDays');
    const licInstEl = document.getElementById('drInfoLicenseInstance');
    const licFpEl = document.getElementById('drInfoLicenseFingerprint');

    if(backendEl) backendEl.textContent = 'Yükleniyor...';
    if(envEl) envEl.textContent = 'Yükleniyor...';
    if(versionEl) versionEl.textContent = 'Yükleniyor...';
    if(instanceEl) instanceEl.textContent = 'Yükleniyor...';

    try {
        const response = await fetch(`${apiBase}/info`);
        if (response.ok) {
            const data = await response.json();
            if(backendEl) backendEl.textContent = data.baseUrl || '-';
            if(envEl) envEl.textContent = data.env || '-';
            if(versionEl) versionEl.textContent = data.version || '-';
            if(instanceEl) instanceEl.textContent = data.instanceName || 'default';
        }
    } catch (err) {
        console.warn('Could not fetch backend info:', err);
        if(backendEl) backendEl.textContent = 'Bilgi alinamadi';
        if(envEl) envEl.textContent = '-';
    }

    // Lisans bilgisi — detayli
    try {
        const licResp = await fetch('/api/license/status');
        const licData = await licResp.json();
        window.__drInfoLicenseData = licData;
        if (licStatusEl) {
            if (licData.status === 'valid') {
                licStatusEl.innerHTML = '<span class="badge bg-success">✅ Geçerli</span>';
            } else {
                licStatusEl.innerHTML = '<span class="badge bg-danger">❌ ' + (licData.message || 'Geçersiz') + '</span>';
            }
        }
        const lic = licData.license || {};
        if (licCustEl) licCustEl.textContent = lic.customerName || '-';
        if (licExpEl) licExpEl.textContent = lic.expiryDate || 'Süresiz';
        if (licDaysEl) {
            if (lic.expiryDate) {
                const d = Math.ceil((new Date(lic.expiryDate) - new Date()) / (1000*60*60*24));
                const color = d <= 0 ? 'text-danger' : d <= 30 ? 'text-warning' : 'text-success';
                licDaysEl.innerHTML = '<span class="' + color + '"><strong>' + d + '</strong> gün</span>';
            } else {
                licDaysEl.textContent = '-';
            }
        }
        if (licInstEl) licInstEl.textContent = lic.instanceName || licData.instanceName || '-';
        if (licFpEl) licFpEl.textContent = licData.fingerprint || '-';
        if (versionEl && licData.version && versionEl.textContent === 'Yükleniyor...') versionEl.textContent = licData.version;
    } catch {
        if (licStatusEl) licStatusEl.textContent = 'Bilgi alınamadı';
    }
}

// Firma bilgilerini yukle
async function loadCompanyInfo() {
    try {
        const resp = await fetch('/api/ui-settings/company');
        const data = await resp.json();
        window.__drInfoCompany = data;
        document.querySelectorAll('.company-field').forEach(el => {
            const k = el.dataset.field;
            el.value = data[k] || '';
        });
        renderCompanyLogo(data.logo);
    } catch (err) {
        console.warn('Firma bilgileri yuklenemedi:', err);
    }
}

function renderCompanyLogo(dataUrl) {
    const box = document.getElementById('companyLogoBox');
    if (!box) return;
    if (dataUrl) {
        box.innerHTML = '<img src="' + dataUrl + '" style="max-width:100%;max-height:140px;object-fit:contain;" alt="Logo">';
    } else {
        box.innerHTML = '<span class="text-muted"><i class="fas fa-image fa-3x"></i><div class="small mt-2">Logo yok</div></span>';
    }
}

function handleCompanyLogoSelect(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
        alert('Logo 2MB\'dan kucuk olmali');
        e.target.value = '';
        return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
        window.__drInfoPendingLogo = ev.target.result;
        renderCompanyLogo(ev.target.result);
    };
    reader.readAsDataURL(file);
}

function removeCompanyLogo() {
    window.__drInfoPendingLogo = '';
    renderCompanyLogo('');
}

async function saveCompanyInfo() {
    const payload = {};
    document.querySelectorAll('.company-field').forEach(el => {
        payload[el.dataset.field] = el.value || '';
    });
    if (window.__drInfoPendingLogo !== undefined) {
        payload.logo = window.__drInfoPendingLogo;
    } else if (window.__drInfoCompany) {
        payload.logo = window.__drInfoCompany.logo || '';
    }
    const btn = document.getElementById('drInfoSaveBtn');
    if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i>Kaydediliyor...'; }
    try {
        const resp = await fetch('/api/ui-settings/company', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        window.__drInfoCompany = await resp.json();
        window.__drInfoPendingLogo = undefined;
        if (btn) { btn.innerHTML = '<i class="fas fa-check me-1"></i>Kaydedildi'; setTimeout(() => { btn.innerHTML = '<i class="fas fa-save me-1"></i>Kaydet'; btn.disabled = false; }, 1500); }
    } catch (err) {
        alert('Kaydedilemedi: ' + err.message);
        if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-save me-1"></i>Kaydet'; }
    }
}

async function ensureTurkishFont(doc) {
    // Roboto fontu Türkçe karakterleri (ç, ş, ğ, ı, ö, ü, İ) destekler
    try {
        if (!window.__drInfoFontB64) {
            const urls = {
                reg: 'https://cdn.jsdelivr.net/gh/googlefonts/roboto@main/src/hinted/Roboto-Regular.ttf',
                bold: 'https://cdn.jsdelivr.net/gh/googlefonts/roboto@main/src/hinted/Roboto-Bold.ttf'
            };
            const toB64 = async (url) => {
                const r = await fetch(url);
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const buf = await r.arrayBuffer();
                const bytes = new Uint8Array(buf);
                let bin = '';
                const chunk = 0x8000;
                for (let i = 0; i < bytes.length; i += chunk) {
                    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
                }
                return btoa(bin);
            };
            const [reg, bold] = await Promise.all([toB64(urls.reg), toB64(urls.bold)]);
            window.__drInfoFontB64 = { reg, bold };
        }
        doc.addFileToVFS('Roboto-Regular.ttf', window.__drInfoFontB64.reg);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.addFileToVFS('Roboto-Bold.ttf', window.__drInfoFontB64.bold);
        doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
        doc.setFont('Roboto', 'normal');
        return 'Roboto';
    } catch (e) {
        try { console.warn('Turkce font yuklenemedi, helvetica kullanilacak:', e); } catch {}
        return 'helvetica';
    }
}

async function exportDrInfoPdf() {
    if (!window.jspdf || !window.jspdf.jsPDF) {
        // jsPDF CDN'den yukle
        await new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }
    if (!window.jspdf.autoTable) {
        await new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.31/jspdf.plugin.autotable.min.js';
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    // Türkçe karakter destekli font yükle
    const fontName = await ensureTurkishFont(doc);
    const company = window.__drInfoCompany || {};
    const lic = window.__drInfoLicenseData || {};
    const licObj = lic.license || {};

    // Logo (varsa sol üstte göster)
    let y = 15;
    let hasLogo = false;
    if (company.logo) {
        try {
            const fmt = (company.logo.match(/^data:image\/(\w+);/) || [])[1] || 'PNG';
            const upFmt = fmt.toUpperCase() === 'JPG' ? 'JPEG' : fmt.toUpperCase();
            doc.addImage(company.logo, upFmt, 15, 10, 30, 30);
            hasLogo = true;
        } catch (e) { try { console.warn('Logo PDF embed hatasi:', e); } catch {} }
    }

    // Başlık — logo varsa sağa kaydır, yoksa ortala
    doc.setFontSize(18);
    doc.setTextColor(50, 31, 219);
    doc.setFont(fontName, 'bold');
    const titleX = hasLogo ? 115 : 105;
    const titleAlign = hasLogo ? 'center' : 'center';
    doc.text('DataRapor Lisans Bilgileri', titleX, 20, { align: titleAlign });
    doc.setFontSize(10);
    doc.setFont(fontName, 'normal');
    doc.setTextColor(100);
    doc.text('Tarih: ' + new Date().toLocaleString('tr-TR'), titleX, 28, { align: titleAlign });
    doc.setTextColor(0);

    // Ortak autoTable stil ayarlari — Türkçe font, satir kaydirma, genis deger sutunu
    const commonTable = {
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 2, overflow: 'linebreak', font: fontName, valign: 'middle' },
        headStyles: { fillColor: [50, 31, 219], textColor: 255, font: fontName, fontStyle: 'bold' },
        columnStyles: { 0: { cellWidth: 40, fontStyle: 'bold' }, 1: { cellWidth: 140 } },
        margin: { left: 15, right: 15 }
    };

    y = 50;
    doc.setFontSize(13);
    doc.setFont(fontName, 'bold');
    doc.setTextColor(50, 31, 219);
    doc.text('Firma Bilgileri', 15, y);
    doc.setTextColor(0);
    y += 4;
    doc.autoTable(Object.assign({}, commonTable, {
        startY: y,
        head: [['Alan', 'Değer']],
        body: [
            ['Firma Adı', company.companyName || '-'],
            ['Adres', company.address || '-'],
            ['Telefon', company.phone || '-'],
            ['E-posta', company.email || '-'],
            ['Web Sitesi', company.website || '-'],
            ['Vergi No', company.taxNumber || '-']
        ]
    }));

    y = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(13);
    doc.setFont(fontName, 'bold');
    doc.setTextColor(50, 31, 219);
    doc.text('Lisans Bilgileri', 15, y);
    doc.setTextColor(0);
    y += 4;
    let daysLeft = '-';
    if (licObj.expiryDate) {
        const d = Math.ceil((new Date(licObj.expiryDate) - new Date()) / (1000*60*60*24));
        daysLeft = d + ' gün';
    }
    doc.autoTable(Object.assign({}, commonTable, {
        startY: y,
        head: [['Alan', 'Değer']],
        body: [
            ['Durum', lic.status === 'valid' ? 'Geçerli' : (lic.message || 'Geçersiz')],
            ['Müşteri', licObj.customerName || '-'],
            ['Geçerlilik Sonu', licObj.expiryDate || 'Süresiz'],
            ['Kalan Gün', daysLeft],
            ['Instance', licObj.instanceName || lic.instanceName || '-'],
            ['Fingerprint', lic.fingerprint || '-']
        ]
    }));

    y = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(13);
    doc.setFont(fontName, 'bold');
    doc.setTextColor(50, 31, 219);
    doc.text('Sistem Bilgileri', 15, y);
    doc.setTextColor(0);
    y += 4;
    doc.autoTable(Object.assign({}, commonTable, {
        startY: y,
        head: [['Alan', 'Değer']],
        body: [
            ['Versiyon', (document.getElementById('drInfoVersion')||{}).textContent || '-'],
            ['Instance', (document.getElementById('drInfoInstance')||{}).textContent || '-'],
            ['Backend URL', (document.getElementById('drInfoBackend')||{}).textContent || '-'],
            ['Ortam', (document.getElementById('drInfoEnv')||{}).textContent || '-']
        ]
    }));

    // Footer: Geliştirici firma bilgileri (her sayfada)
    const pageCount = doc.internal.getNumberOfPages();
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        // Ayirici çizgi
        doc.setDrawColor(50, 31, 219);
        doc.setLineWidth(0.4);
        doc.line(15, pageH - 20, pageW - 15, pageH - 20);
        // Gelistirici etiketi
        doc.setFontSize(8);
        doc.setFont(fontName, 'bold');
        doc.setTextColor(50, 31, 219);
        doc.text('Geliştirici Firma', 15, pageH - 15);
        // Firma adi ve adres
        doc.setFont(fontName, 'normal');
        doc.setTextColor(80);
        doc.setFontSize(8);
        doc.text('ZAKE Mühendislik Çevre Tek. ve Tek. Emn. Sis. San. ve Tic. Ltd. Şti.', 15, pageH - 10);
        doc.text('Uzayçağı Cad. No:62/4 OSTİM / ANKARA', 15, pageH - 6);
        // Sayfa numarasi
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text('Sayfa ' + i + ' / ' + pageCount, pageW - 15, pageH - 6, { align: 'right' });
    }

    doc.save('DataRapor-Info-' + new Date().toISOString().slice(0,10) + '.pdf');
}

/**
 * Fetches UI configuration and toggles menu items (Header & Sidebar)
 * Also loads generic report list into the Reports dropdown
 */
async function fetchAndApplyMenuConfig() {
  try {
    const response = await fetch('/api/ui-settings/menu');
    if (!response.ok) return;
    const config = await response.json();
    
    // 1. Toggle Header Item
    const showEvents = config.showEvents !== false;
    const headerEventsItem = document.getElementById('navItemEvents');
    if (headerEventsItem) {
      headerEventsItem.style.display = showEvents ? '' : 'none';
    }

    const headerReportItem = document.getElementById('navItemReports');
    if (headerReportItem) {
        headerReportItem.style.display = config.showReports ? '' : 'none';
    }

    // 1b. Toggle individual report links (Chiller, 5min)
    const modules = (config.modules && config.modules.reports) || {};
    const chillerItem = document.getElementById('navItemChillerReport');
    if (chillerItem) chillerItem.style.display = (modules.chiller !== false) ? '' : 'none';
    const fiveMinItem = document.getElementById('navItem5minReport');
    if (fiveMinItem) fiveMinItem.style.display = (modules.fiveMin !== false) ? '' : 'none';

    // 2. Toggle Sidebar Item
    const sidebarLinks = document.querySelectorAll('.sidebar .nav-link, .sidebar-nav .nav-link');
    sidebarLinks.forEach(link => {
        if (link.textContent.trim().includes('Raporlar') || (link.getAttribute('href') && link.getAttribute('href').includes('Report'))) {
            const parentItem = link.closest('.nav-item');
            if (parentItem) {
                parentItem.style.display = config.showReports ? '' : 'none';
            }
        }
    });

    // 3. Load generic report configs into dropdown
    if (config.showReports) {
      loadGenericReportsDropdown();
    }

  } catch (e) {
    console.warn('Error applying menu config:', e);
  }
}

/**
 * Loads generic report configs and adds them to the Reports dropdown menu
 */
async function loadGenericReportsDropdown() {
  try {
    const res = await fetch('/api/v1/report/configs');
    if (!res.ok) return;
    const json = await res.json();
    const reports = json.data || [];
    if (reports.length === 0) return;

    const menu = document.getElementById('reportsDropdownMenu');
    const divider = document.getElementById('reportsDropdownDivider');
    if (!menu) return;

    // Show divider between Chiller and generic reports
    if (divider) divider.style.display = '';

    // Add generic reports
    reports.forEach(r => {
      const li = document.createElement('li');
      const iconName = r.icon || 'cil-chart';
      li.innerHTML = `<a class="dropdown-item" href="/Report/GenericReport?report=${encodeURIComponent(r.id)}">
        <svg class="icon icon-sm me-2"><use xlink:href="vendors/@coreui/icons/svg/free.svg#${iconName}"></use></svg>${r.title}
      </a>`;
      menu.appendChild(li);
    });

    // Add "Tüm Raporlar" link at the end
    const allLi = document.createElement('li');
    allLi.innerHTML = '<hr class="dropdown-divider">';
    menu.appendChild(allLi);
    const viewAllLi = document.createElement('li');
    viewAllLi.innerHTML = `<a class="dropdown-item text-primary fw-semibold" href="/Report/GenericReport">
      <svg class="icon icon-sm me-2"><use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-list-rich"></use></svg>Tüm Raporlar
    </a>`;
    menu.appendChild(viewAllLi);

    // Add "Rapor Tasarımcısı" link (admin only)
    const designerLi = document.createElement('li');
    designerLi.innerHTML = `<a class="dropdown-item text-warning" href="/admin/report-designer">
      <svg class="icon icon-sm me-2"><use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-pencil"></use></svg>Rapor Tasarımcısı
    </a>`;
    menu.appendChild(designerLi);
  } catch (e) {
    console.warn('Error loading generic reports dropdown:', e);
  }
}

// ─── VERSION CHECK — Güncelleme bildirimi (tüm sayfalarda) ──────────
(function initVersionCheck() {
  let currentVersion = null;
  const CHECK_INTERVAL = 30000; // 30 saniyede bir kontrol

  async function checkVersion() {
    try {
      const res = await fetch('/admin/api/nexbus/info');
      if (!res.ok) return;
      const data = await res.json();
      const serverVersion = data.version;
      if (!serverVersion) return;
      if (currentVersion === null) {
        currentVersion = serverVersion;
        return;
      }
      if (serverVersion !== currentVersion) {
        showUpdateToast(serverVersion);
        currentVersion = serverVersion;
      }
    } catch (e) { /* sessizce yut */ }
  }

  function showUpdateToast(newVersion) {
    if (document.getElementById('versionUpdateToast')) return;
    const toast = document.createElement('div');
    toast.id = 'versionUpdateToast';
    toast.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:999999;background:#1e293b;color:#fff;border:1px solid #3b82f6;border-radius:8px;padding:14px 20px;box-shadow:0 8px 32px rgba(0,0,0,0.4);display:flex;align-items:center;gap:12px;font-size:14px;max-width:500px;animation:slideDown .3s ease;';
    toast.innerHTML = '<i class="fas fa-arrow-circle-up" style="color:#3b82f6;font-size:20px;"></i>' +
      '<div style="flex:1;"><b>Güncelleme mevcut!</b><br><small style="color:#94a3b8;">Yeni sürüm: v' + newVersion + '</small></div>' +
      '<button onclick="location.reload()" style="background:#3b82f6;color:#fff;border:none;border-radius:6px;padding:8px 16px;cursor:pointer;font-size:13px;white-space:nowrap;">Yenile</button>' +
      '<button onclick="this.parentElement.remove()" style="background:none;border:none;color:#64748b;cursor:pointer;font-size:18px;padding:0 4px;">✕</button>';
    document.body.appendChild(toast);
    if (!document.getElementById('versionToastStyle')) {
      const style = document.createElement('style');
      style.id = 'versionToastStyle';
      style.textContent = '@keyframes slideDown{from{opacity:0;transform:translateX(-50%) translateY(-20px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}';
      document.head.appendChild(style);
    }
  }

  setTimeout(checkVersion, 5000);
  setInterval(checkVersion, CHECK_INTERVAL);
})();
// ─── /VERSION CHECK ────────────────────────────────────────
